import React from 'react';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import { useCreateAllowList } from 'src/features/allowList/api/useCreateAllowList';
import { LIST_ALLOW_LISTS_RESOURCE } from 'src/features/allowList/api/useListAllowLists';
import AllowListFormModal from 'src/features/allowList/components/forms/AllowListFormModal';
import { allowListMessages } from 'src/features/allowList/utils/allowListMessages';
import { ALLOW_LIST_TYPE } from 'src/features/allowList/utils/types';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { useParking } from 'src/providers/ParkingProvider';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';

interface AllowListFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

export default function CreateWhiteListFormModal<TData>({ className, semantics }: AllowListFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();
    const { mutate, isPending } = useCreateAllowList({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ALLOW_LISTS_RESOURCE] });
            toast({
                title: formatMessage(allowListMessages.createWhiteListSuccess),
                description: formatMessage(allowListMessages.createWhiteListSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <AllowListFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ parkingId, data: values }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={faPlus}
            isPending={isPending}
            subtitle={formatMessage(allowListMessages.addWhiteListSubtitle)}
            type={ALLOW_LIST_TYPE.WHITE}
        />
    );
}
